const text = {
	global: {
		team:     'Team',
		device:   'Appareil',
		devices:  'Appareils',
		price:    'Prix',
		quantity: 'Quantité',
		all:      'Tout',

		computer:   'Ordinateur',
		tablet:     'Tablette',
		phone:      'Téléphone',
		computers:  'Ordinateurs',
		tablets:    'Tablettes',
		phones:     'Téléphones',
		hub:        'Docks',
		headphones: 'Casques',
		mouse:      'Souris',
		speaker:    'Enceinte',
		screen:     'Écran',
		sim:        'Forfait mobile',
		other:      'Autre',

		name: 'Nom',
		role: 'Rôle',

		save:       'Enregistrer',
		saveChange: 'Enregistrer les changements',

		password:    'Mot de passe',
		firstname:   'Prénom',
		lastname:    'Nom',
		username:    'Nom d\'utilisateur',
		job:         'Poste dans l\'entreprise',
		email:       'Email',
		phoneNumber: 'Numéro de téléphone',

		description:        'Description',
		descriptionAndNote: 'Description et notes',
		processor:          'Processeur',
		processorCore:      'Core',
		screenSize:         'Taille d\'écran',
		stockage:           'Stockage',
		memory:             'Mémoire (RAM)',
		gpu:                'GPU',
		graphicCard:        'Carte graphique',
		network:            'Réseau',
		connectivity:       'Connectivité',
		keyboard:           'Clavier',
		format:             'Format',
		dataVolume:         'Data',
		year:               'Année',
		state:              'État à l’achat',
		type:               'Type',
		brand:              'Marque',
		serial:             'Numéro de série',
		imei:               'IMEI',
		valala:             'Valala',
		supplier:           'Fournisseur',
		funder:             'Financeur',
		notValala:          'Externe',
		contractStart:      'Début du contrat',
		contractEnd:        'Fin du contrat',
		guaranteeEnd:       'Fin de garantie',
		purchasePrice:      'Prix d\'achat',
		duration:           'Durée',
		rent:               'Loyer',
		contractNumber:     'N° de contrat',
		billingNumber:      'N° de facture',
		deliveryAddress:    'Adresse de livraison',
		deliveryContact:    'Contact de livraison',
		purchaseType:       'Mode d\'acquisition',
		deviceType:         'Type d\'appareil',
		monthlyPrice:       'Loyer mensuel',
		purchaseDate:       'Date d\'achat',
		purchasePriceNoTax: 'Prix d’achat en € HT',
		warrantyEnd:        'Fin de garantie',
		contract:           'Contrat',
		address:            'Adresse',
		contact:            'Contact',
		owner:              'Propriétaire',
		status:             'Statut',
		internalId:         'ID Interne',
		compatibility:      'Compatibilité',
		definition:         'Définition',
		refreshRate:        'Taux de rafraîchissement',
		responseTime:       'Temps de réponse',
		ports:              'Ports',
		anc:                'Réduction de bruit',
		batteryLife:        'Autonomie',
		subType:            'Type',
		optimisedFor:       'Optimisé pour',
		microphone:         'Microphone',
		camera:             'Caméra',
		stand:              'Pied',
		siret:              'Raison sociale, SIREN, SIRET..',
		optional:           'optionnel',
		see:                'Voir',
		replace:            'Remplacé par',

		subTotal:   'Sous-total',
		delivery:   'Livraison',
		total:      'Total loyer',
		totalPrice: 'Total',
		free:       'Gratuite',

		search: 'Recherche',
		add:    'Ajouter',
		filter: 'Filtrer',
		sortBy: 'Trier par',
		reset:  'Réinitialiser',

		fileToBig: 'Le fichier est trop volumineux',

		date:   'Date',
		second: 'seconde',
		minute: 'minute',
		hour:   'heure',
		day:    'jour',
		month:  'mois',
		// year:   'année',

		select:         'Sélectionner',
		cancel:         'Annuler',
		cancelAndLeave: 'Annuler et quitter',
		confirm:        'Confirmer',
		confirmAndSave: 'Confirmer et sauvegarder',
		validAndSave:   'Valider et sauvegarder',
		next:           'Suivant',
		previous:       'Précédent',
		continue:       'Continuer',
		resetFilter:    'Réinitialiser les filtres',
		edit:           'Modifier',
		close:          'Fermer',
		connected:      'Connecté',
		notConnected:   'Non connecté',
		soonAvailable:  'Bientôt disponible',
		soon:           'Bientôt',
		connectTo:      'Se connecter à %var1%',
		reconnectTo:    'Se reconnecter à %var1%',

		lease:          'Location',
		purchase:       'Achat',
		new:            'Neuf',
		refurbished:    'Reconditionné',
		details:        'Détails',
		characteristic: 'Caractéristiques',
		documents:      'Documents',
		affect:         'Affecter',
		duplicate:      'Dupliquer',
		action:         'Action',
		noTax:          'HT',

		sortAtoZ:            'Alphabétique A-Z',
		sortZtoA:            'Alphabétique Z-A',
		sortRecent:          '+ récents',
		sortOlder:           '+ anciens',
		sortAscendingPrice:  'Prix croissant',
		sortDecreasingPrice: 'Prix décroissant',

		about:    'À propos',
		delete:   'Supprimer',
		download: 'Télécharger',
		back:     'Retour',

		sirh: 'SIRH',
		pro:  'Pro',
		yes:  'Oui',
		no:   'Non',

		tags:              'Tags',
		editTags:          'Modifier les tags',
		tagsTitle:         'Ajouter et sélectionner des tags',
		tagsDescription:   'Les tags vous permettent de trier et classifier vos employés selon leurs affectations, lieux de travail, équipes etc. Vous pouvez créer autant de tags que vous le souhaitez.',
		tagsPressEnter:    'Cliquez sur “Entrée” pour valider la création d’un nouveau tag.',
		validateSelection: 'Valider la sélection',
		chooseColumn:      'Choisir les colonnes',
		tickets:           'Tickets',

		needeed: 'Obligatoire'
	},

	login: {
		hello:           'Bonjour !',
		niceToSeeYou:    'Content de vous voir de retour.',
		rememberMe:      'Se souvenir de moi',
		forgotPassword:  'Mot de passe oublié',
		login:           'Se connecter',
		google:          'avec Google',
		weWillSendMail:  'Nous allons vous envoyer par mail un lien de réinitialisation de votre mot de passe.',
		sendMail:        'Envoyer le mail',
		tooManyRequest:  'Vous avez fait trop de demandes réinitialisation de mot de passe, veuillez patienter avant de recommencer',
		forgetMailSend:  'Un email de réinitialisation de mot de passe a été envoyé à votre adresse e-mail enregistrée, si celle-ci existe.',
		choosePassword:  'Choisissez votre mot de passe',
		notEasyPassword: 'Ne choisissez pas un mot de passe trop simple pour protéger votre entreprise.',
		passwordRules:   {
			text:  'Votre mot de passe doit contenir :',
			rules: ['8 caractères minimum', '1 majuscule', '1 minuscule', '1 chiffre', '1 caractère spécial']
		},
		confirmPassword:  'Confirmez votre mot de passe',
		validatePassword: 'Valider mon mot de passe',
		accountCreate:    'Compte créé',
		passwordSave:     'Votre mot de passe a bien été enregistré. Vous pouvez désormais vous connecter à notre application',
		createAccount:    'Créer un compte',
		register:         'Votre inscription',
		registerText:     'Renseignez vos informations pour créer votre compte MyValala gratuitement.',
		useForLogin:      'Il vous servira à vous connecter à notre application.',
		registerConfirm:  'Votre demande d’inscription a bien été prise en compte. Nous allons procéder à la vérification des informations renseignées. Une fois terminée, vous recevrez un mail pour vous inviter à créer votre mot de passe.',
		doubleAuth:       'Double authentification',
		mfa:              'Entrez le code à 6 chiffres généré par votre application d\'authentification pour compléter la connexion.',

		backToLogin:      'Revenir à l\'accueil',
		existingAccount:  'Déjà un compte ?',

		error: {
			loginError:   'Mauvais email ou mot de passe',
			empty:        'Veuillez remplir tout les champs',
			loginTooMany: 'Vous avez fait trop de tentative de connection, veuillez patienter avant de recommencer',
			siret:        'Ce numéro n’est pas reconnu, veuillez réessayer ou ',
			proEmail:     'Veuillez utilisez votre email professionnel',
			siretIsUse:   'Un compte a déjà été créé pour cette entreprise, rapprochez-vous de votre administrateur pour y accéder ou vous créer un accès.',
			contactUs:    'nous contacter',
			mfa:          '',
			wrongMfa:     'Le code que vous avez entré est incorrect. Veuillez essayer à nouveau.'
		}
	},

	menu: {
		home:        'Dashboard',
		devices:     'Appareils',
		mobileLines: 'Lignes téléphoniques',
		order:       'Commandes',
		users:       'Employés',
		contracts:   'Contrats',
		support:     'Support',
		settings:    'Paramètres',
		logout:      'Se déconnecter',

		chooseAccount:    'À quel compte souhaitez-vous accéder ?',
		selectAndConfirm: 'Sélectionnez puis confirmez.'
	},

	header: {
		newCommand:   'Nouvelle commande',

		devices: {
			yourDevices: 'Vos appareils',
			mdm:         'Votre MDM',
			add:         'Ajout d\'appareils',
			redemption:  'Rachat de parc'
		},

		users: {
			employee:    'Mes employés',
			HRIS:        'Votre SIRH',
			onboarding:  'Onboarding',
			offboarding: 'Offboarding',
			addEmployee: 'Ajout d\'employés'
		},

		order: {
			myOrders: 'Mes commandes',
			catalog:  'Catalogue'
		},

		contract: {
			minimize:  'Vers vos contrats',
			contracts: 'Mes contrats',
			add:       'Ajouter un contrat'
		}
	},

	dashboard: {
		title:             'Votre dashboard',
		inventoryDevice:   'Appareils',
		inStockDevice:     'Équipements en stock',
		endSoon:           'Contrats expirants dans 3 mois',
		openTicket:        'SAV en cours de résolution',
		setRead:           'Marquer comme lu',
		area:              'Nombre d’appareils loués chez Valala',
		pie:               'Répartition de la flotte'
	},

	devices: {
		title:          'Vos équipements',
		openTicket:     'Ouvrir un ticket',
		newCommand:     'Nouvelle commande',
		yourDevice:     'Votre appareil',
		assignAndState: 'Affectation et état',
		description:    'Gérez ici l\'état et l\'attribution de vos appareils.',
		search:         'Tapez un nom ou un n° de série',

		selectDevice:         'Sélectionnez un appareil',
		selectDeviceText:     'Pour commencer à gérer votre équipement, cliquez sur l’un de vos appareils dans la liste de gauche ou créez-en un nouveau',
		addDevice:            'Ajouter un appareil',
		setDeviceData:        'Remplissez les informations de l’appareil',
		addDeviceImportTitle: 'Ajout d\'appareils par lots',
		addDeviceImportData:  'Téléversez votre fichier *.csv',

		addDeviceManually:     'Ajout manuel depuis Valala',
		addDeviceManuallyText: 'Pour quand vous souhaitez ajouter un seul appareil à votre équipe ou que vous préférez remplir les informations depuis l’interface de Valala.',
		addDeviceImport:       'Ajout par lot (*.csv)',
		addDeviceImportText:   'Pour quand vous souhaitez ajouter de nombreux appareils d’un coup ou que vous préférez passer par l’utilisation d’un fichier CSV.',

		deviceStatus: {
			active:      'En service',
			stock:       'En réserve',
			replacement: 'Remplacement',
			locationEnd: 'Location terminée',
			needRepair:  'À réparer',
			repair:      'En réparation',
			broken:      'Hors service'
		},

		inReserve:           'Mettre en réserve',
		createTicket:        'Créer un ticket',
		moreInfo:            'Plus d\'informations',
		historical:          'Historique',
		affect:              'Affectez cet appareil',
		uploadBy:            'Téléversé par ',
		deviceDocuments:     'Documents de cet appareil',
		downloadDocuments:   'Téléchargez des documents',
		deviceDocumentRules: '(max. 2mo)',
		soon:                'Cette fonctionnalité arrive bientôt !',
		soonText:            'Nous allons déployer la vue “historique” dans la prochaine version de Valala. Il vous tarde ? Nous aussi !',
		noDocument:          'Pas de documents',
		noDocumentText:      'Il n’y a pas encore de documents liés à cet appareils. Vous pouvez en ajouter directement ci-dessous.',
		aboutDevice:         'A propos de l\'appareil',
		characteristic:      'Caractéristiques',
		assignDevice:        'Attribuer un appareil',
		seeDevices:           'Voir les appareils',
		deviceName:          'Nom de l\'appareil',
		purchasePrice:       'Prix d’achat en € HT',
		deviceTags:          'Tags de cet appareil',
		yourFile:            'Votre fichier CSV',
		mapping:             'Mapping des colonnes',
		assignDevices:       'Attribuer les appareils',
		backToDevices:       'Vers votre équipement',
		backToMdm:           'Vers l\'onglet MDM',

		similarDevice:      'Cette personne possède déjà un appareil similaire',
		similarDeviceText:  'Attention : vous souhaitez attribuer à votre employé un appareil alors que celui-ci en possède déjà un similaire.',
		selectAffectDevice: 'Si cela est volontaire, confirmez cet ajout.',
		assignThisDevices:  'Attribuer tous ces appareils',

		selectOneDevice:  'Sélectionner un appareil',
		chooseThisDevice: 'Choisir cet appareil',
		downloadTemplate: 'Téléchargez notre template Valala',
		uploadCsv:        'Téléversez votre fichier CSV',
		onlyCSV:          'Fichier CSV uniquement',

		addDeviceSuccess:    'Votre appareil a été ajouté avec succès',
		addDeviceSuccesText: 'Vous pouvez désormais sélectionner un appareil dans la barre latérale de gauche ou en ajouter un nouveau',

		mdm: {
			selectConfiguration:     'Sélectionnez une configuration',
			selectConfigurationText: 'Les logiciels listés dans la configuration vont être ajoutés aux appareils que vous avez sélectionnés.',
			selectAccount:           'Sélectionnez l\'utilisateur',
			selectAccountText:       'L\'utilisateur et ses données seront supprimés de l\'appareil. La liste suivante est mise à jour tous les jours et peut ne pas être exacte.',
			selectAccountManual:     'Écrire manuellement le nom d\'utilisateur',
			addAccount:              'Ajouter un utilisateur',
			addAccountText:          'Veuillez remplir les informations de l\'utilisateur à ajouter',
			addAccountType:          'Type de compte',
			resetPassword:           'Demander à l\'utilisateur de choisir un nouveau mot de passe à la première connexion.',
			uninstallCheck:          'Désinstaller des applications de l\'ordinateur.',
			guest:                   'Invité',
			admin:                   'Administrateur',
			actionDate:              'Veuillez choisir une date d’exécution de l’action. Par défaut, elle sera programmée en même temps que le départ de l’employé.',
			dateInput:               'Date de déclenchement',
			hours:                   'Heure de déclenchement',

			actions: {
				restart:          'Redémarrer l’appareil',
				restart_short:    'Redémarrer',
				shutDown:         'Éteindre l’appareil',
				shutDown_short:   'Éteindre',
				setConfiguration: 'Attribuer une configuration',
				reset:            'Réinitialiser l’appareil',
				erase:            'Effacer l\'appareil',
				lock:             'Verrouiller l\'appareil',
				deleteAccount:    'Supprimer un utilisateur',
				addAccount:       'Ajouter un utilisateur',
				applications:     'Afficher les applications',
				update:           'Mettre à jour',
				compliance:       'Évaluation de conformité',
				alerts:           'Alertes de sécurité'
			},
			actionsText: {
				restartTitle:          'L’appareil sélectionné va redémarrer.',
				restartText:           'Les données non sauvegardées sur vos logiciels pourraient être perdues.',
				shutDownTitle:         'L’appareil sélectionné va s\'éteindre',
				shutDownText:          'Les données non sauvegardées sur vos logiciels pourraient être perdues.',
				setConfigurationTitle: 'Confirmez l’ajout de %var1% a l\'appareil sélectionné',
				setConfigurationText:  'Les logiciels de la configuration vont être ajoutés a l\'appareils que vous avez sélectionné.',
				resetTitle:            'Êtes-vous sûr de vouloir effacer les données ?',
				lockTitle:             'L’appareil sélectionné va étre verrouiller',
				resetText:             'Opération irréversible : l’ordinateur sera totalement remis à zéro et le MDM sera désinstallé de cet ordinateur.',
				lockText:              'Saisissez un code PIN de déverrouillage à 6 chiffres pour effectuer l\'action Verrouiller l\'appareil',
				lockInput:             'Définir le code de déverrouillage :',
				lockDescription:       'Cet appareil ne peut pas être déverrouillé à distance et ne peut être déverrouillé qu\'à l\'aide de ce code PIN à 6 chiffres. Si vous ne disposez pas de ce code PIN, vous devez contacter Apple pour déverrouiller l\'appareil.',
				lockDescriptionInput:  'Note (facultatif), ce message s’affichera sur l’écran de verrouillage.',
				lockError:             'Ne doit pas commencer par 0',

				deleteAccountTitle: 'Supprimer l\'utilisateur "%var1%" ?',
				deleteAccountText:  'Si cet utilisateur existe, toutes ses données seront supprimées. L\'appareil pourrait redémarrer pendant le processus.',

				addAccountTitle: 'Ajouter l\'utilisateur "%var1%" ?',
				addAccountText:  'L\'ajout d\'un utilisateur peut prendre plusieurs minutes avant d\'apparaître sur l\'appareil.',
				addAccountCheck: ' L\'appareil va redémarrer pendant le processus.',

				applicationsTitle: 'Applications',
				complianceTitle:   'Évaluation de conformité',
				alertsTitle:       'Alertes de sécurité',

				updateTitle: 'L’appareil sélectionné va démarrer une mise à jour',
				updateText:  ''
			},

			version:           'Version',
			bundleId:          'ID du bundle',
			group:             'Groupe',
			level:             'Niveau d\'erreur',
			onlyError:         'Afficher uniquement les erreurs',
			date:              'Date',
			uninstall:         'Désinstaller',

			syncDevices:       'Synchronisez et gérez vos appareils %var1%',
			syncText:          'Vous pouvez gérer vos appareils liés à %var1% depuis votre application Valala.',
			learnMore:         'En savoir plus',
			enroll:            'MDM',
			devicesManagement: 'Gérer les appareils',
			sendInvitation:    'Envoi d\'invitation',
			sendAInvitation:   'Envoyer une invitation',
			unavailable:       'Incompatible MDM',
			assign:            'Appareil non assigné',
			invitationPage:    'Voir page d\'invitation',
			vmWareOnly:        'Neccesite VmWare',

			learnMoreJamfTitle:             'Que puis-je faire avec l’intégration Jamf Pro de Valala ?',
			fromPerMonth:                   'à partir de 7,90€/mois par appareil',
			setPreConfiguration:            'Attribuer des configurations pré-établies',
			setPreConfigurationDetail:      'Vous pouvez créer depuis Jamf Pro des listes de logiciels à installer en quelque clics sur les appareils de votre entreprise. Ne perdez plus de temps à configurer tous vos appareils lors de leur réception, choisissez la facilité.',
			restartRemotely:                'Redémarrer à distance un appareil',
			eraseDeviceRemotely:            'Effacer toutes les données d’un appareil à distance',
			shutdownRemotely:               'Éteindre à distance un appareil',
			loggingToJamf:                  'Connexion à Jamf Pro',
			loggingToVmWare:                'Connexion à VmWare',
			connectionBetweenJamfAndValala: 'Nous allons établir une connexion entre l’API de Jamf Pro et votre compte Valala.',
			connectionVmWareAndValala:      'Nous allons établir une connexion entre l’API de VmWare Workspace ONE et votre compte Valala.',
			jamfUrl:                        'URL (exemple : https://valala.jamfcloud.com)',
			jamfLogin:                      'Identifiant de connexion Jamf Pro',
			jamfPassword:                   'Mot de passe Jamf Pro',
			connectToJamf:                  'Se connecter à Jamf Pro',
			vmWareUrl:                      'URL Workspace ONE UEM (exemple : https://cn2060.awmdm.com)',
			vmWareKey:                      'Clé API',
			vmWareLogin:                    'Identifiant de connexion VmWare',
			vmWarePassword:                 'Mot de passe VmWare',
			connectToVmWare:                'Se connecter à VmWare',
			noAccount:                      'Je n’ai pas encore de compte',
			askLicense:                     'Demander une licence à Valala',
			askJamfLicense:                 'Demande de licence Jamf Pro',
			askJamfLicenseText:             'Valala peut vous fournir une licence Jamf Pro grâce à son partenariat avec l’éditeur de la solution. Après votre demande, nous vous rappellerons pour créer votre compte et gérer vos licences.',
			message:                        'Message',
			send:                           'Envoyer le message',
			sendConfirm:                    'Demande envoyée à notre équipe',
			sendConfirmText:                'Nous allons vous recontacter prochainement.\u000AVous pouvez fermer cette fenêtre.',

			welcome:         'Bienvenue dans votre espace %var1%',
			manageDevices:   'Gérez et synchronisez vos appareils depuis cet espace',
			goTo:            'Vers %var1%',
			noSyncDevices:   'Vous n’avez aucun appareil synchronisés',
			importForManage: 'Pour gérer vos appareils, veuillez d’abord les importer depuis votre MDM',
			importDevices:   'Importer des appareils',
			syncWithValala:  'Synchronisation entre Valala et %var1%',
			informations:    'Informations',
			correspondence:  'Correspondances',
			otherDevices:    'Autres appareils',
			validate:        'Validation',

			howSyncWork:           'Comment fonctionne la synchronisation ?',
			howSyncWorkText:       'La synchronisation de vos appareils %var1% avec ceux présents dans votre inventaire Valala fonctionne à partir de la correspondance entre leur numéro de série. Lorsqu’aucune correspondance n’est trouvée pour l’un de vos appareils %var2%, vous avez le choix de sélectionner manuellement l’appareil avec lequel le synchroniser ou de créer une nouvelle carte appareil sur Valala à partir des données importées.',
			whatDataImported:      'Quelles données vont être importées ? ',
			whatDataImportedText:  'Toutes les données présentes dans l’onglet “Matériel” de votre appareil sur %var1% seront ajoutées aux caractéristiques déjà présentes dans les détails de votre appareil sur Valala.',
			syncLater:             'Est-ce que je peux synchroniser plus tard ?',
			syncLaterText:         'Oui, vous pouvez synchroniser vos appareils plus tard, à tout moment et autant de fois que nécessaire !',
			devicesCorrespondence: 'appareils %var1% possèdent une correspondance avec un appareil Valala',
			selectEnroll:          'Sélectionner les appareils dont les numéros de série concordent et actuellement non enrôlés',
			hideEnroll:            'Masquer les appareils %var1% déjà enrôlés sur Valala',
			backToMdm:             'Retour vers le MDM',
			deviceDetects:         'Appareil détecté chez %var1%',
			noMatch:               'Pas de correspondance avec Valala',
			selectFromInventory:   'Sélectionner un appareil dans votre inventaire',
			createDevice:          'Créer un nouvel appareil',
			dontImport:            'Ne pas importer cet appareil',
			deviceWillNotBeLinked: 'L’appareil détecté chez %var1% ne sera lié à aucun appareil Valala.',
			supersededBy:          'Les caractéristiques relatives à cet appareil seront remplacées par les informations issues de %var1%.',
			editSelection:         'Modifier la sélection',
			recap:                 'Récapitulatif : %var1% nouveaux appareils vont être enrôlés sur Valala depuis %var2%',
			hideDontImport:        'Masquer les appareils à ne pas importer',
			enrollment:            'Enrôlement',
			selection:             'Via sélection',
			creation:              'Création',
			configuration:         'Configurations',
			invitation:            'Invitations',
			sendInvitations:       'Envoyer les invitations',

			historyStatus:  'Statut',
			historyPending: 'En cours',
			historySuccess: 'Réussi',
			historyError:   'Erreur',
			historyDate:    'Date',
			historyCommand: 'Action',
			historyMessage: {
				name:    'Message',
				pending: 'Certaines commandes peuvent prendres plusieurs minutes à être prise en compte, l\'appareil doit être connecté à internet'
			},

			deviceFullData: {
				model:                  'Modèle',
				model_identifier:       'Identifiant du modèle',
				serial_number:          'Numéro de série',
				wifi_mac_address:       'Adresse Mac Wifi',
				bluetooth_mac_address:  'Adresse Mac Bluetooth',
				capacity_mb:            'Mémoire RAM totale',
				battery_level:          'Capacité de la batterie',
				make:                   'Marque',
				processor_speed:        'Vitesse du processeur',
				number_processors:      'Nombre de processeur',
				number_cores:           'Nombre total de coeurs',
				processor_type:         'Type de processeur',
				is_apple_silicon:       'Puce Apple',
				processor_architecture: 'Type d’architecture',
				bus_speed:              'Vitesse du bus',
				cache_size:             'Taille du cache',
				network_adapter_type:   'Type d’adaptateur réseau principal',
				mac_address:            'Adresse Mac Principale',
				alt_mac_address:        'Adresse Mac Secondaire',
				total_ram:              'Mémoire RAM totale',
				available_ram_slots:    'Emplacements de RAM disponibles',
				battery_capacity:       'Capacité de la batterie',
				smc_version:            'Version SMC',
				nic_speed:              'Vitesse de la carté réseau',
				optical_drive:          'Lecteur optique',
				boot_rom:               'Mémoire ROM de démarrage'
			}
		},

		modal: {
			removeAssignSave:    'Sauvegarder la mise en réserve',
			removeAssignConfirm: 'Voulez-vous confirmer la mise en réserve de cet appareil ?',
			saveDetails:         'Sauvegarder les modifications des détails de l’appareils',
			saveDetailsConfirm:  'Voulez-vous confirmer les changements réalisés sur cet appareil avant de quitter ? Tout changement non sauvegardé sera perdu.',
			users:               'Vos employés',
			typeAName:           'Tapez un nom',

			deleteDevice:          'Êtes-vous sûr de vouloir supprimer cet appareil ? ',
			deleteDeviceTextPart1: 'L’appareil ',
			deleteDeviceTextPart2: ' sera supprimé de votre inventaire et de notre base de donnée. Cette action est irréversible. '
		},

		import: {
			propertyName: 'Nom de la propriété Valala',
			columnName:   'Nom de la colonne du fichier',
			exemple:      'Exemple du document',
			status:       'Statut',
			import:       'Import',
			success:      'Réussi',
			needFix:      'Erreurs à corriger',
			howItsWork:   'Comment ça fonctionne ?',
			step2Text1:   'Sélectionnez dans les menus déroulant la colonne de votre fichier qui correspond à la propriété Valala.',
			step2Text2:   'Les propriétés Valala pour lesquelles aucune colonne n’a été affecté ne seront pas importées.',
			step3Text1:   'L’affectation des appareils n’est pas obligatoire.',
			step3Text2:   'Vous pourrez également affecter individuellementvos appareils une fois ceux-ci importés dans l’application Valala.'
		},

		importFileHeader: [
			{name: 'Nom de l’appareil*', exemple: 'Ex : iPhone 13'},
			{name: 'Mode d\'acquisition*', exemple: 'Ex : Location, Achat'},
			{name: 'Catégorie*', exemple: 'Ex : Ordinateur'},
			{name: 'Etat à l\'achat*', exemple: 'Ex : Neuf'},
			{name: 'Etat actuel', exemple: 'Ex : En service, en réserve'},
			{name: 'ID Interne', exemple: 'Ex : 10005, AAAACD'},
			{name: 'N° de série', exemple: 'Ex : 8975411'},
			{name: 'Fournisseur', exemple: 'Ex : Apple'},
			{name: 'Début du contrat', exemple: 'Ex : 06/07/2019'},
			{name: 'Durée en mois', exemple: 'Ex : 12, 24, 36'},
			{name: 'Loyer mensuel', exemple: 'Ex : 24,90'},
			{name: 'N° de contrat', exemple: 'Ex : C01887'},
			{name: 'Prix d\'achat HT', exemple: 'Ex :  1499,99'},
			{name: 'Date d\'achat', exemple: 'Ex : 01/02/2021'},
			{name: 'Fin de garantie', exemple: 'Ex : 01/02/2023'},
			{name: 'N° de facture', exemple: 'Ex : F01458'},
			{name: 'Notes ou description', exemple: 'Ex : Ordinateurs pour alternants'},
			{name: 'Marque', exemple: 'Ex : Apple'},
			{name: 'Modèle', exemple: 'Ex : MacBook Pro M1'},
			{name: 'Taille de l\'écran en pouces', exemple: 'Ex : 13, 15, 17'},
			{name: 'Clavier', exemple: 'Ex : Français - AZERTY'},
			{name: 'Stockage', exemple: 'Ex : 256 Go'},
			{name: 'Mémoire RAM', exemple: 'Ex : 16 Go'},
			{name: 'Processeur', exemple: 'Ex : i7'},
			{name: 'Carte Graphique', exemple: 'Ex : Ti 3060'},
			{name: 'Réseau', exemple: 'Ex : Wifi'},
			{name: 'Utilisateur', exemple: 'Jean Dupond'}
		],

		importError: {
			unknow:       'Champ incorrect',
			mustBeNumber: 'Non reconnu comme un nombre',
			mustBeDate:   'Non reconnu comme une date',
			stockageType: 'GO ou TO non précisé'
		}
	},

	mobileLines: {
		title:    'Vos lignes',

		add:       'Ajouter une ligne',
		number:    'Numéro',
		user:      'Utilisateur',
		operator:  'Opérateur',
		package:   'Type de forfait',
		data:      'Data',
		simFormat: 'Format SIM',
		puk:       'PUK',

		sim: {
			physical: 'SIM Physique',
			esim:     'E-SIM'
		},

		qr:             'QR code d\'activation',
		lineNumber:     'Numéro de ligne',
		smdp:           'SM-DP+',
		activationCode: 'Code d\'activation',

		status: {
			cancelScheduledTerminationInProgress: 'Réactivation en cours',
			cancelled:                            'Annulé',
			inProgress:                           ' En cours',
			reactivationInProgress:               'Réactivation en cours',
			rejected:                             'Rejetée',
			restricted:                           'Restreinte',
			restrictionInProgress:                'Restriction en cours',
			scheduleTerminationInProgress:        'Résiliation en cours',
			scheduledTermination:                 'Résiliation en cours',
			settingInProgress:                    'Paramétrage en cours',
			suspended:                            'Suspendue',
			suspensionInProgress:                 'Suspension en cours',
			terminated:                           'Résiliée',
			terminationInProgress:                'Résiliation en cours',
			used:                                 'Active'
		},
		planTypes: {
			classic:    'Packagé',
			dataonly:   'Data only',
			unpackaged: 'Dépackagé'
		}
	},

	users: {
		title:   'Votre équipe',
		newUser: 'Nouvelle commande',
		search:  'Tapez le nom d\'un employé',

		addUserManually:     'Ajout manuel depuis Valala',
		addUserManuallyText: 'Ajouter une seule personne et remplir ses informations directement depuis l’interface.',
		addUserImport:       'Ajout par lot (*.csv)',
		addUserImportText:   'Ajoutez plusieurs personnes d’un coup en passant par l’import d’un fichier CSV.',
		addUserGoogle:       'Ajouter depuis Google',
		addUserGoogleText:   'Importez dans Valala tous les employés connectés à votre compte Google d\'entreprise',

		selectUser:          'Sélectionnez un employé',
		selectUserText:      'Pour commencer à gérer vos employés, cliquez sur l’un de vos employés dans la liste de gauche ou créez-en un nouveau',
		addUser:             'Ajouter un employé',
		yourUser:            'Votre employé',
		addTags:             'Ajouter des tags à cet employé (pôle, équipe, ville, pays..)',
		userDevice:          'Equipement de votre employé',
		setDevice:           'Attribuer un appareil',
		setDevices:          'Attribuer des appareils',
		emptyDevices:        'Votre employé n’a pas encore d’appareils attribués. Cliquez sur le bouton “attribuer un appareil ci-dessous”.',
		createIn2Minute:     'Créez son profil en deux minutes',
		aboutUser:           'À propos de l’employé',
		noDocumentText:      'Il n’y a pas encore de documents liés à cet utilisateur. Vous pouvez en ajouter directement ci-dessous.',
		profilPicture:       'Photo de profil',
		avatarRules:         'PNG, JPG, JPEG ou GIF (max. 1mo)',
		userDocuments:       'Documents de l’employé',
		addUserSuccess:      'Votre employé a été ajouté avec succès',
		addUserSuccessText:  'Vous pouvez désormais sélectionner un employé dans la barre latérale de gauche ou en ajouter un nouveau',
		emailAlreadyExist:   'Cet email est déjà utilisé',
		emailNotValid:       'Veuillez entrer une adresse e-mail valide.',
		phoneNotValid:       'Veuillez entrer un numéro valide.',
		upComingOnboarding:  'Onboarding à venir',
		upComingOffboarding: 'Offboarding à venir',
		assignTo:            'Appareil attribués à ',
		backToTeam:          'Vers votre équipe',
		backToHris:          'Vers l\'accueil SIRH',
		permission:          'Permission',

		modal: {
			devices:        'Vos appareils',
			typeAName:      'Tapez un nom',
			stockOnly:      'Réserve uniquement',
			validAndFilter: 'Valider et filtrer',
			filterSearch:   'Filtres de recherche',

			deviceAlreadyInUse:     'Attribution d’un appareil déjà utilisé',
			deviceAlreadyInUseText: 'Attention : vous souhaitez attribuer à votre employé un appareil déjà utilisé. La validation de cette action supprimera l’appareil de l’inventaire de son propriétaire initial.',
			selectDevice:           'Sélectionnez les appareils pour confirmer votre action.',
			assingAgain:            'Réattribuer les appareils sélectionnés',
			cancelSelection:        'Annuler cette sélection',

			deleteUser:          'Êtes-vous sûr de vouloir supprimer cet employé ? ',
			deleteUserTextPart1: 'L’employé ',
			deleteUserTextPart2: ' sera supprimé de votre liste et de notre base de donnée. Cette action est irréversible. ',

			userRight:      'Voulez vous envoyer les accès à votre employé ?',
			userRightText:  'Pour passer votre employé en %var1%, vous devez envoyer les accès.',
			adminRightOnly: 'Voulez vous définir votre employé en tant qu\'Admin ?',
			adminRightText: 'Celui-ci pourra à son tour modifier les permissions des autres membres'
		},

		importFileHeader: [
			{name: 'Prénom*', exemple: 'Ex : Mathieu'},
			{name: 'Nom*', exemple: 'Ex : Vergnes'},
			{name: 'Email*', exemple: 'Ex : mathieu@valala-shop.fr'},
			{name: 'Poste', exemple: 'Ex : Directeur Marketing'},
			{name: 'Début du contrat', exemple: 'Ex : 04/09/2022'},
			{name: 'Fin du contrat', exemple: 'Ex : 12/06/2024'}
		],

		importError: {
			emailExist: 'Cette adresse e-mail est déjà utilisée'
		},

		hris: {
			establishment:       'Établissement',
			establishments:      'Sélectionnez les établissements',
			changeEstablishment: 'Changer d\'établissement',
			importUsers:         'Importer vos employés depuis %var1%',
			importText:          'Vous pouvez importer la liste de vos employés depuis le compte %var1% de votre entreprise.',
			import:              'Importer',
			connectTo:           'Connexion à %var1%',
			connexionWithvalala: 'Nous allons établir une connexion entre l’API de %var1% et votre compte Valala.',
			url:                 'URL (exemple: https://valala.ilucca.net)',
			apiKey:              'Clé API'
		},

		onboarding: {
			startDate:   'Arrivée prévue le',
			status:      'Etat de l\'onboarding',
			complete:    'Complet',
			unstart:     'Non commencé',
			needAssign:  'Appareil à assigner',
			assign:      'Assigner des appareils',
			fromStock:   'Depuis le stock',
			hide:        'Ne plus afficher',
			addToValala: 'Ajouter dans MyValala',
			addModal:    'Définir une date d\'arivée ?'
		},

		offboarding: {
			title:       'Suivi des Offboarding',
			button:      'Créer un Offboarding',
			endDate:     'Départ prévue le',
			status:      'Etat de l\'offboarding',
			complete:    'Complet',
			unstart:     'Non commencé',
			start:       'Commencer l\'offboarding',
			cancel:      'Annuler l\'offboarding',

			add: {
				title:            'Offboarding d’employés',
				text:             'Remplissez les informations concernant le départ de vos employés et la mise à disposition de leurs matériels.',
				deviceManagement: 'Gestion de ses appareils',
				selectUsers:      'Sélectionnez les employés',
				leaveDate:        'Date de départ',
				leaveHours:       'Heure de départ',
				deviceAction:     'Que souhaitez-vous faire des appareils ?',
				sellToValala:     'Le faire estimer pour revente à Valala',
				sellText:         'Nous allons recevoir les caractéristiques de votre appareil et nous feront une offre de rachat pour celui-ci.',
				mdm:              'Action à distance via votre MDM',
				nothing:          'Ne rien faire',
				erase:            'Effacer les données',
				eraseText:        'Les appareils seront remis aux paramètres d’usine. Attention, cette action est irréversible. L’action sera effectuée quand l’appareil sera : allumé et connecté à internet.',
				removeMdm:        'Déconnecter du MDM',
				removeText:       'L’action sera effectuée quand l’appareil sera : allumé et connecté à internet',
				deleteAccount:    'Supprimer un utilisateur'
			}
		}
	},

	contract: {
		title:          'Vos contrats',
		current:        ' en cours',
		sign:           'Signé',
		needSign:       'Signature nécessaire',
		contractNumber: 'Contrat n°',
		the:            'Le',
		contractDevice: 'Equipement lié à ce contrat',
		number:         'Numéro de contrat',

		selectContract:         'Sélectionnez un contrat',
		selectContractText:     'Pour commencer à gérer vos contrats, cliquez sur l’un d\'eux dans la liste de gauche ou ajoutez manuellement un contrat.',
		addContract:            'Ajouter un contrat',
		signBy:                 'Signé par',
		monthlyPrice:           'Coût mensuel HT',
		setContractDescription: 'Remplissez les informations relatives au contrat',
		aboutContract:          'A propos du contrat',
		deviceLinkToContract:   'Appareils liés au contrat',
		contractDocument:       'Documents du contrat',
		noDocumentText:         'Il n’y a pas encore de documents liés à ce contrat. Vous pouvez en ajouter directement ci-dessous.',
		contractName:           'Nom du contrat',

		contractStatus: {
			sign:        'Signé',
			notValala:   'Fournisseur externe',
			locationEnd: 'Terminé',
			needAction:  'Échéance : action requise'
		},

		addContractChoice:     'Choix du mode d’ajout des appareils au contrat',
		addContractChoiceText: 'Vous avez la possibilité d’ajouter manuellement des appareils qui ne sont pas encore dans l’inventaire, ou de sélectionner parmi ceux déjà présents.',
		manualAdd:             'Ajout manuel',
		deviceInInventory:     'Appareils dans l\'inventaire',
		owner:                 'Propriétaire',
		affect:                'Affecter',
		addSelection:          'Ajouter à la selection',
		confirmSelection:      'Confirmer la sélection',
		yourSelection:         'Votre sélection',
		remove:                'Retirer',
		addDevices:            'Ajouter des appareils',
		fromInventory:         'Depuis l\'inventaire',
		manual:                'Manuellement',
		setDeviceName:         'Nommez votre appareil',
		assignADevice:         'Affecter un appareil',
		assignDevice:          'Affecter l\'appareil',
		newDevice:             'Nouveau'
	},

	order: {
		title:               'Vos commandes',
		titleLimited:        'Votre commande',
		current:             'en cours',
		order:               'Commande',
		the:                 'Le',
		selectOrder:         'Sélectionnez une commande ou débutez-en une nouvelle.',
		selectOrderLimited:  'Sélectionnez une commande.',
		selectDevices:       'Sélection des appareils',
		validateFunder:      'Demande de financement',
		validateFunderText:  'Nous sommes en train d’étudier votre dossier de financement. Une fois celui-ci validé, nous vous enverrons le contrat à signer par mail.',
		signContract:        'Signature du contrat',
		signContractText:    'Nous sommes en train d’étudier votre dossier de financement. Une fois celui-ci validé, nous vous enverrons le contrat à signer par mail.',
		preparation:         'Préparation de votre commande',
		devicesdelivery:     'Livraison de vos appareils',
		devicesdeliveryText: 'Votre commande est en cours de livraison. Vous pouvez suivre son statut à partir du lien ci-dessus.',
		deliveryConfirm:     'Confirmation de la livraison',
		newCommand:          'Nouvelle commande',
		trackDelivery:       'Suivre ma livraison',
		trackOrder:          'Suivi de commande',
		yourOrder:           'Votre commande',
		yourContract:        'Votre contrat',
		yourContractText:    'Votre contrat sera disponible une fois finalisé et signé par toutes les parties.',
		downloadContract:    'Vous pouvez télécharger votre contrat.',
		seeProperty:         'Voir les propriétés',
		end:                 'Terminé',
		needDocument:        'Afin de finaliser la validation de votre location, nous aurions besoin d’informations suplémentaires.',
		needDocumentUpload:  'Ajouter mes documents',
		checkDocument:       'Vos document sont en cours de vérification par notre équipe',
		number:              'Numéro de commande',
		orderedBy:           'Commandé par',
		esimAssign:          'L\'envoi du QR code nécessite l\'assignation préalable de l\'eSIM.',

		addOrder:          'Nouvelle commande',
		catalog:           'Catalogue',
		seeOptions:        'Voir les options',
		priceStart:        'à partir de ',
		optionsFor:        'Nos options pour ',
		selectConfig:      'Sélectionnez votre configuration idéale.',
		leaseDuration:     'Durée de location',
		deliveryDelay:     'Délais de livraison',
		deliveryDay:       '2 à 3 jours',
		quantity:          'Quantité souhaitée',
		addBasket:         'Ajouter au panier',
		addBundle:         'Ajouter dans un pack',
		myBasket:          'Mon panier',
		object:            'objet',
		objects:           'objets',
		basketEmpty:       'Il n\'y a pas encore de produits dans votre panier',
		backCatalog:       'Revenir au catalogue',
		continuePurchase:  'Continuer mes achats',
		validAndContinue:  'Valider et poursuivre',
		selectAddress:     'Sélectionnez l’adresse de livraison de chaque appareil',
		selectAddressText: 'Vous pouvez envoyer chaque appareil à l’adresse de votre choix, ou tous les appareils au même endroit.',
		sendSameAddress:   'Envoyer tous les appareils au même endroit',
		orderEnd:          'Finalisation de votre demande',
		orderEndText:      'Vérifiez les informations relatives à votre commande avant de valider votre demande.',
		orderEndTextPart2: 'Nous l’examinerons ensuite puis nous vous enverrons le contrat à signer par mail.',
		validateOrder:     'Valider la demande',
		only36Month:       'Nous ne proposons pour le moment que des locations sur 36 mois pour les commandes en ligne',
		userMail:          'Qui recevra les mails de gestion (financeurs, signature contrat...) ?',
		userMailTracking:  'Qui recevra les mails de suivi (livraison) ?',
		comment:           'Ajouter un commentaire',
		needCharger:       'Chargeur non fourni',
		noCharger:         'Ce produit est loué sans chargeur',
		chargerPopup:      {
			title: 'Pourquoi le chargeur est-il proposé séparément ?',
			text:  'Conformément à la réglementation européenne sur le chargeur universel, certains appareils sont désormais proposés sans chargeur afin de limiter les déchets électroniques. Si vous n\'avez pas de chargeur compatible, vous pouvez en ajouter un à votre commande.',
			apple: '*Pour les appareils Apple, le câble de recharge est inclus, mais l’adaptateur secteur (bloc de charge) est vendu séparément.'
		},

		selectOneOrder:  'Sélectionner une commande',
		chooseThisOrder: 'Choisir cette commande',

		legalText: {
			readAccept:         'J’ai lu et j’accepte les ',
			generalCondition:   'conditions générales',
			asWellAs:           ' ainsi que ',
			dataProtection:     'la politique de protection des données',
			and:                ' et ',
			insuranceCondition: 'les conditions générale d’assurance.'
		},

		status: {
			underReview:        'En cours d\'examen',
			beingValidated:     'En cours de validation',
			refusedByFunder:    'Annulée',
			refusedByValala:    'Annulée',
			cancel:             'Annulée',
			needDocument:       'Documents supplémentaires à fournir',
			contractToBeSigned:	'Contrat à signer',
			inPreparation:      'En préparation',
			inPreparationOrder: 'En préparation',
			shipped:            'Expédiée',
			delivered:          'Livrée'
		},

		bundle: {
			bundle:             'Pack',
			addBundle:          'Créer un nouveau Pack',
			addToBundle:        'Ajouter dans le Pack',
			name:               'Nom du pack',
			backToList:         'Retour liste des Packs',
			alreadyInBundle:    'Appareil déjà dans le Pack',
			nameExist:          'Le nom du Pack est déjà utilisé',
			legacyPopup:        'Un ou plusieurs appareils ne sont plus disponibles dans notre catalogue.',
			legacyDevicePopup:  'Cet appareil n\'est plus disponible dans notre catalogue.'
		}
	},

	support: {
		title:        'Votre SAV',
		current:      'en cours',
		ticket:       'ticket',
		number:       'Numéro de SAV',
		lastMessage:  'Dernier message',
		last:         'Il y a',
		openBy:       'Ouvert par',
		closeTicket:  'Fermer le ticket',
		closeConfirm: 'Êtes-vous sûr de vouloir fermer ce ticket SAV ? Une fois fermé, il ne sera plus possible d’y répondre, sauf en le réouvrant.',
		notice:       'Êtes-vous satisfait de notre support ?',

		selectOrOpenTicket: 'Sélectionnez un de vos tickets ou ouvrez en un nouveau',
		openTicket:         'Ouvrir un ticket',
		openTicketText:     'Vous pouvez nous communiquer un problème concernant l’un de vos appareils, l’un de vos contrats ou l’une de vos commandes.',
		waitTreatment:      'En attente de traitement',
		waitTreatmentText:  'Nous consultons votre problème et nous allons vous contacter sous les meilleurs délais afin de trouver une solution à votre problème.',
		inProgress:         'En cours de résolution par le SAV',
		inProgressText:     'Nous vous avons contacté par téléphone ou nous allons le faire sous peu pour vous proposer une solution à votre problème.',
		ticketClose:        'Ticket cloturé',
		ticketOn:           'Ticket sur',
		ticketTracking:     'Suivi de ticket',
		discussionFollow:   'Suivi de conversation',
		you:                'Vous',
		valalaSupport:      'SAV de Valala',
		valalaTeam:         'Team Valala',
		writeMessage:       'Tapez votre message à destination du SAV',

		new:                    'Nouveau ticket de SAV',
		problemConcerns:        'Votre problème concerne...',
		chooseSubject:          'Choisir un sujet',
		device:                 'Un appareil',
		order:                  'Une commande / Un contrat',
		mdm:                    'Mobile Device Management (MDM)',
		selectDevice:           'Sélectionnez l\'appareil en question',
		selectOrder:            'Sélectionnez la commande en question',
		devicePattern:          'Motif',
		deviceAddress:          'Adresse de livraison en cas de remplacement',
		problemDescription:     'Décrivez votre problème',
		descriptionPlaceHolder: 'Décrivez votre problème pour que le SAV comprenne votre situation',
		addPicture:             'Ajouter des photos du problème',
		documentsRules:         'PDF ou image (max. 2mo)',
		sendTicket:             'Envoyer le ticket',

		patternList: [
			'Appareil photo / Caméra',
			'Son / Audio',
			'Allumage / Batterie',
			'Réseau / GPS / Bluetooth / Wi-Fi',
			'Écran (pixel / tactile / casse)',
			'Logiciel / Application / Configuration / Installation',
			'Autres'
		],

		status: {
			new:         'Ticket ouvert',
			done:        'Résolu',
			replacement: 'Remplacement',
			inProgress:  'En cours de résolution'
		}
	},

	settings: {
		title:           'Vos paramètres',
		myAccount:       'Mon compte',
		identification:  'Identification',
		users:           'Utilisateurs',
		myCompany:       'Mon entreprise',
		address:         'Adresses',
		actualPassword:  'Mot de passe actuel',
		newPassword:     'Nouveau mot de passe',
		confirmPassword: 'Répetez le nouveau mot de passe',
		mustBeIdentical: 'Il doit être identique à celui écrit dans “Nouveau mot de passe”.',
		passwordRules:   {
			text:           'Votre mot de passe doit contenir les éléments suivants :',
			rules:          ['8 caractères', 'Une lettre minuscule', 'Une lettre majuscule', 'Un chiffre', 'Un caractère spécial'],
			inludeUsername: 'Le mot de passe ne doit pas contenir le nom d\'utilisateur'
		},
		mfa:               'Authentification à deux facteurs',
		mfaText:           'Ajoutez la sécurité supplémentaire en configurant l\'authentification à deux facteurs.',
		mfaAdd:            'Ajouter l\'authentification',
		mfaScan:           'Scannez le QR Code avec Google Authenticator',
		mfaInput:          'Entrez le code affiché sur Google Authenticator :',
		mfaValidate:       'Vérifier le code',
		config:            'Activé',
		companyName:       'Nom de votre entreprise',
		siret:             'SIRET',
		mainAddress:       'Adresse de livraison principale',
		billingAddress:    'Adresse de facturation principale',
		documents:         'Documents de l\'entreprise',
		newAddress:        'Nouvelle adresse',
		addAddress:        'Ajouter une adresse',
		editAddress:       'Modifier',
		backToList:        'Retour liste des adresses',
		addressName:       'Intitulé de cette adresse',
		street:            'Numéro + Rue',
		complement:        'Complément d\'adresse',
		postalCode:        'Code postal',
		city:              'Ville',
		country:           'Pays',
		incompleteAddress: 'Adresse incomplète',
		setPermission:     'Donner les permissions "%var1%"',
		idCardData:        'Nom et prénom présent sur la carte',
		documentDate:      'Date d\'effet du document',
		upload:            'Téléverser',

		documentsType: {
			companyBalance:   'Liasse de l’entreprise',
			idCard:           'CNI du gérant',
			bankStatement:    'RIB de l’entreprise',
			kbis:             'KBIS',
			powerOfSignature: 'Pouvoir de signature',
			idCardSignatory:  'CNI signataire'
		}
	},

	placeholder: {
		firstname: 'Martin',
		lastname:  'Matin',
		email:     'nom@entreprise.fr',
		phone:     '+33600000000',
		date:      'Format JJ/MM/AAAA',
		job:       'exemple : Cheffe de projet'
	},

	component: {
		input: {
			clickToUpload:       'Cliquez ici pour téléverser',
			orDrag:              ' ou glissez-déposez ici'
		},
		device: {
			seeDevice: 'Voir l\'appareil'
		},
		externalApi: {
			google: 'Google',
			payfit: 'PayFit',
			silae:  'Silaé',
			jamf:   'Jamf',
			intune: 'Microsoft Intune',
			vmWare: 'VMWare',
			lucca:  'Lucca'
		}
	},

	notifications: {
		error: {
			title:        'Erreur',
			messagePart1: 'L\'erreur suivante a été retournée : '
		},
		fileDownloadDone: {
			title:        'Fichier téléchargé',
			messagePart1: 'Les modifications apportées à ',
			messagePart2: ' ont été enregistrées.'
		},
		editSuccess: {
			title:        'Modifications enregistrées',
			messagePart1: 'Les modifications apportées à ',
			messagePart2: ' ont été enregistrées.'
		},
		addDeviceSuccess: {
			title:        'Appareil correctement crée',
			messagePart1: '',
			messagePart2: ' a été ajouté à l’inventaire.'
		},
		addMultipleDevicesSuccess: {
			title:        'Appareils correctement créés',
			messagePart1: '',
			messagePart2: ' appareils ont été ajoutés à l’inventaire.'
		},
		assignDeviceSuccess: {
			title:        'Appareil correctement attribué',
			messagePart1: 'Les modifications apportées à ',
			messagePart2: ' ont été enregistrées.'
		},
		removeAssignDeviceSuccess: {
			title:        'Appareil correctement retiré',
			messagePart1: 'Les modifications apportées à ',
			messagePart2: ' ont été enregistrées.'
		},
		removeDeviceInventorySuccess: {
			title:        'Appareil correctement retiré',
			messagePart1: '',
			messagePart2: ' a été supprimé de l’inventaire.'
		},
		deleteDeviceSuccess: {
			title:        'Appareil supprimé',
			messagePart1: 'Nous avons bien pris en compte la suppression de l\'appareil '
		},
		addUser: {
			title:        'Employé correctement créé',
			messagePart1: '',
			messagePart2: ' a été ajouté à l’inventaire.'
		},
		addMultipleUsersSuccess: {
			title:        'Employés correctement créés',
			messagePart1: '',
			messagePart2: ' employés ont été ajoutés à l’inventaire.'
		},
		deleteUserSuccess: {
			title:        'Suppression de l’employé confirmée',
			messagePart1: 'L’employé a correctement été supprimé de votre liste.'
		},
		editSettingsSuccess: {
			title:        'Paramètres modifiés',
			messagePart1: 'Nous avons bien pris en compte la modification de vos paramètres.'
		},
		editPasswordSuccess: {
			title:        'Mot de passe modifié',
			messagePart1: 'Nous avons bien pris en compte la modification de votre mot de passe.'
		},
		editPasswordError: {
			title:        'Erreur de mot de passe',
			messagePart1: 'Le mot de passe que vous avez tapé n’est pas correct. Veuillez vérifier les informations et réessayer.'
		},
		editMainAddressSuccess: {
			title:        'Adresse de livraison principale changée',
			messagePart1: 'Nous avons bien pris en compte la modification de votre adresse de livraison par défaut.'
		},
		editBillingAddressSuccess: {
			title:        'Adresse de facturation principale changée',
			messagePart1: 'Nous avons bien pris en compte la modification de votre adresse de facturation par défaut.'
		},
		addAddressSuccess: {
			title:        'Création de l\'adresse réussie',
			messagePart1: 'Les détails de ',
			messagePart2: ' ont bien été enregistrés.'
		},
		editAddressSuccess: {
			title:        'Votre adresse a bien été modifiée',
			messagePart1: 'Nous avons bien pris en compte les changements apportés à '
		},
		deleteAddressSuccess: {
			title:        'Adresse supprimée',
			messagePart1: 'Nous avons bien pris en compte la suppression de l’adresse.'
		},
		addContractSuccess: {
			title:        'Contrat correctement ajouté',
			messagePart1: 'Votre ',
			messagePart2: ' a bien été ajouté.'
		},
		addBasketSuccess: {
			title: 'Ajouté au panier'
		},
		addOrderSuccess: {
			title:        'Commande effectuée',
			messagePart1: 'Votre commande ',
			messagePart2: ' a bien été enregistrée. Vous allez recevoir un mail de confirmation.'
		},
		addSupportSuccess: {
			title:        'Ticket ouvert',
			messagePart1: 'Nous avons bien reçu votre demande de SAV. Nous allons revenir vers vous très rapidement.'
		},
		editTagsSuccess: {
			title:        'Tags enregistrés',
			messagePart1: 'Vos changements ont été pris en compte.'
		},
		mdmActionRestartSuccess: {
			title:        'Redémarrage de l’appareil lancé',
			messagePart1: 'L\'appareil sélectionné entame son redémarrage.'
		},
		mdmActionShutDownSuccess: {
			title:        'Arrêt de l’appareil lancé',
			messagePart1: 'L\'appareil sélectionné entame son arrêt.'
		},
		mdmActionSetConfigurationSuccess: {
			title:        'Ajout de la configuration',
			messagePart1: 'Les logiciels de la configuration sélectionnée vont être ajoutés.'
		},
		mdmActionResetSuccess: {
			title:        'Réinitialisation de l\'appareil',
			messagePart1: 'L\'appareil sélectionné entame une remise à zéro.'
		},
		mdmActionLockSuccess: {
			title:        'Verrouillage de l\'appareil',
			messagePart1: 'L\'appareil sélectionné entame son verrouillage.'
		},
		mdmActionDeleteAccountSuccess: {
			title:        'Supprimer un utilisateur',
			messagePart1: 'L\'utilisateur sélectionné est en cours de suppression. Vous pouvez suivre l\'avancement dans l\'historique des actions MDM.'
		},
		mdmActionAddAccountSuccess: {
			title:        'Ajouter un utilisateur',
			messagePart1: 'Le compte utilisateur va être créé sur l’appareil.'
		},
		mdmActionUpdateSuccess: {
			title:        'Mise à jour',
			messagePart1: 'La mise à jour va démarrer.'
		},
		mdmActionApplicationsSuccess: {
			title:        'Désinstallation',
			messagePart1: 'L’application va être désinstallée.'
		},
		mdmConnectSuccess: {
			title:        'Connexion réussie',
			messagePart1: 'Connexion à ',
			messagePart2: ' réussie.'
		},
		mdmConnectError: {
			title:        'Erreur',
			messagePart1: 'Mauvais identifiant.'
		},
		mdmInvitationSendSingle: {
			title:        'Invitation envoyée',
			messagePart1: '',
			messagePart2: ' invitation a été envoyée par mail.'
		},
		mdmInvitationSend: {
			title:        'Invitations envoyées',
			messagePart1: '',
			messagePart2: ' invitations ont été envoyées par mail.'
		},
		addCompanyBundleSuccess: {
			title:        'Création du Pack réussi',
			messagePart1: 'Les détails de ',
			messagePart2: ' ont bien été enregistrés.'
		},
		editCompanyBundleSuccess: {
			title:        'Modification du Pack réussi',
			messagePart1: 'Les détails ont bien été enregistrés.'
		},
		activeMFASuccess: {
			title:        'Authentification activée',
			messagePart1: 'L\'authentification à deux facteurs est maintenant activée sur votre compte.'
		}
	},

	dashboardNotification: {
		replacement: [
			'Un <b>remplacement</b> de ',
			'vous a été envoyé.'
		],
		end1Month: [
			'La location de ',
			' <b>arrive à échéance</b> dans moins d\'un mois'
		],
		end1Week: [
			'La location de ',
			' <b>arrive à échéance</b> dans moins d\'une semaine'
		],
		needReturn: [
			'Vous devez <b>retourner</b> ',
			' auprès de Valala'
		],
		noDevice: [
			'',
			' n\'a plus <b>aucun appareil affecté</b>'
		],
		newUserNoDevice: [
			'',
			' a été ajouté <b>sans lui affecter d\'appareil</b>'
		],
		sign: [
			'',
			' vous à été envoyé par mail pour signature'
		],
		resolve: [
			'Le ticket ',
			' concernant ',
			' <b>a été résolu</b>'
		],
		newMessage: [
			'Vous avez un <b>nouveau message</b> pour le ticket ',
			' concernant ',
			''
		]
	},

	filters: {
		deviceType:         'Type d\'appareil',
		computer:           '',
		tablet:             '',
		phone:              '',
		other:              'Autre équipement',
		deviceStatus:       'Statut de l\'appareil',
		active:             '',
		stock:              '',
		replacement:        '',
		supplier:           '',
		valala:             '',
		notValala:          'Externe',
		underReview:        '',
		beingValidated:     '',
		refusedByFunder:    '',
		refusedByValala:    '',
		needDocument:       '',
		contractToBeSigned:	'',
		inPreparation:      '',
		shipped:            '',
		delivered:          '',
		orderStatus:        '',
		new:                '',
		done:               '',
		inProgress:         '',
		supportStatus:      '',
		brand:              '',
		processor:          '',
		stockage:           '',
		state:              '',
		memory:             '',
		network:            '',
		tags:               '',
		compatibility:      '',
		definition:         '',
		refreshRate:        '',
		responseTime:       '',
		ports:              '',
		anc:                '',
		batteryLife:        '',
		subType:            '',
		optimisedFor:       '',
		microphone:         '',
		camera:             '',
		stand:              '',
		gpu:                '',
		processorCore:      '',
		deviceMdm:          '',
		needAction:         '',
		sign:               '',
		locationEnd:        '',
		contractStatus:     ''
	}
};

text.filters = {
	...text.global,
	deviceType:     'Type d\'appareil',
	computer:       text.global.computer,
	tablet:         text.global.tablet,
	phone:          text.global.phone,
	other:          'Autre équipement',
	deviceStatus:   'Statut de l\'appareil',
	supplier:       text.global.supplier,
	valala:         text.global.valala,
	...text.contract.contractStatus,
	notValala:      'Externe',
	orderStatus:    'Statut de la commande',
	supportStatus:  'Statut du ticket',
	tags:           'Tags',
	deviceMdm:      'MDM',
	contractStatus: 'Statut du contrat',
	...text.devices.deviceStatus,
	...text.support.status,
	...text.order.status
};

export default text;
